import React, { useEffect, useState } from 'react'
import AlertComponent from '../../components/AlertComponent'
import { useDispatch, useSelector } from 'react-redux';
import ModalComponent from '../../components/ModalComponent'
import { openForm } from '../../redux/slice/roleSlice';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Wrapper from '../../components/scrollbar/scrollBarComponent';
import { getModulList } from '../../redux/action/modulAction';
import { postRoleModule } from '../../redux/action/roleModuleAction';
// import { postRoles } from '../../redux/action/roleAction';

const FormRole = () => {
    const { dataRole, isOpenForm, isLoading, state } = useSelector( (state) => state.role );
    const { dataModul } = useSelector( (state) => state.modul)
    // console.log(dataModul)
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const param = {
    token: user.access_token,
    }
    const [activeItem, setActiveItem] = useState(null);
    const [collapsedRows, setCollapsedRows] = useState([]);
    const [roleModul, setRoleModul] = useState([]);
    const initialValues = {
        name: '',
        descr: '',
    }
    const initialValuesRoleModul = {
        roleId: '',
        modulId: '',
        create: '',
        read: '',
        update: '',
        delete: '',
    }
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required!'),
        descr: Yup.string().required('Deskripsi is required!'),
    })

    const handleFormSubmit = async (values) => {
    // console.log(values)
    if (state === "add") {
        param.data = values;
        param.roleModule = roleModul;
        // console.log(param.data);
        dispatch(postRoleModule(param));
      }
        // else if (state === 'edit') {
        //     param.data = values
        //     param.data.image = imagebase
        //     param.id = dataByIdSites.siteId
        //     dispatch(editSites(param))
        // } else {
        //     param.id = dataByIdSites.siteId;
        //     dispatch(deleteSites(param));
        // }
    }
    const checkAll = (id, parentId) => {
        let arr = [...roleModul] 
        if(parentId === ''){
            let arr =[...roleModul]
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id === id) {
                    arr[i].create = !arr[i].all;
                    arr[i].update = !arr[i].all;
                    arr[i].delete = !arr[i].all;
                    arr[i].read = !arr[i].all;
                    arr[i].all = !arr[i].all;
                }
            }
        }else{
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id === parentId) {
                    for (var x = 0; x < arr[i].subMenu.length; x++) {
                        if (arr[i].subMenu[x].id === id) { 
                            arr[i].subMenu[x].create = !arr[i].subMenu[x].all;
                            arr[i].subMenu[x].update = !arr[i].subMenu[x].all;
                            arr[i].subMenu[x].delete = !arr[i].subMenu[x].all;
                            arr[i].subMenu[x].read = !arr[i].subMenu[x].all;
                            arr[i].subMenu[x].all = !arr[i].subMenu[x].all;
                        }
                    }
                }
            }
        }
        // console.log(arr)
        setRoleModul(arr)
    }
    const handleCheck = (id, state,parentId, type) => {
        let arr =[...roleModul]
        if(parentId === ''){
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id === id) {
                    if(type === 'create'){
                        arr[i].create = !state; 
                    } else if(type === 'read'){
                        arr[i].read = !state; 
                    } else if(type === 'update'){
                        arr[i].update = !state; 
                    } if(type === 'delete'){
                        arr[i].delete = !state; 
                    }
                }
            }
        } else{
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id === parentId) {
                    for (var x = 0; x < arr[i].subMenu.length; x++) {
                        // console.log(id)
                        if (arr[i].subMenu[x].id === id) {
                            if(type === 'create'){
                                // console.log(arr[i].subMenu[x].create)
                                arr[i].subMenu[x].create = !state; 
                            } else if(type === 'read'){
                                arr[i].subMenu[x].read = !state; 
                            } else if(type === 'update'){
                                arr[i].subMenu[x].update = !state; 
                            } if(type === 'delete'){
                                arr[i].subMenu[x].delete = !state; 
                            }
                        }
                    }
                }
            }
        }
        setRoleModul(arr)
    }

    const toggleRow = (index) => {
        // console.log(collapsedRows.includes(index));
        // console.log(collapsedRows);
        if (collapsedRows.includes(index)) {
          setCollapsedRows(collapsedRows.filter((rowIndex) => rowIndex !== index));
        } else {
          setCollapsedRows([...collapsedRows, index]);
        }
      };

      useEffect(() => {
        dispatch(getModulList(param));
        // eslint-disable-next-line
      }, []);

    useEffect(()=>{
        let arr = []
        dataModul.map((key, index)=>{
            let newObj = {}
            newObj.id = key.id
            newObj.name = key.name
            newObj.descr = key.descr
            newObj.create = false
            newObj.update = false
            newObj.delete = false
            newObj.read = false
            newObj.all = false
            newObj.subMenu = key.subMenu
            if(key.subMenu.length > 0){
                let arrSub = []
                key.subMenu.map((keySub, indexSub)=>{
                    let objSub = {}
                    objSub.id = keySub.id
                    objSub.parentId = keySub.parentId
                    objSub.name = keySub.name
                    objSub.descr = keySub.descr
                    objSub.create = false
                    objSub.update = false
                    objSub.delete = false
                    objSub.read = false
                    objSub.all = false
                    arrSub.push(objSub)
                })
                newObj.subMenu = arrSub
            }
            // newObj.create = false
            // console.log(newObj)
            arr.push(newObj)
            // key.read = false;
            // key.update = false;
            // key.delete = false;
            // arr.push(key)
        })
        setRoleModul(arr)
    },[dataModul])

    return (
      <ModalComponent
        title={state === 'add' ? 'TAMBAH ROLE' : 'EDIT ROLE'}
        show={isOpenForm}
        close={() => dispatch(openForm({ open: false, type: 'close' }))}
        idForm="role-form"
      >
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
           {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
            <form onSubmit={handleSubmit} id="role-form">
              <div className='row align-items-center' style={{color: 'white'}}>
              <div className="row">
                <div className="col-xl-3 col-lg-12">
                    <label htmlFor="staticEmail" className="col-sm-2 col-form-label">Name</label>
                        <div style={{ paddingBottom: '10px'}}>
                        <input onChange={handleChange}
                            type="text"
                            name="name"
                            id="name"
                            className='form-control'
                            value={values.name}
                            validation={{ touched: touched.name, errors: errors.name }}
                            props={{
                            onBlur: handleBlur,
                            }}
                        />
                        {touched.name && errors.name && <span style={{ color: 'red' }}>{errors.name}</span>} 
                        </div>

                    <label htmlFor="staticEmail" className="col-sm-2 col-form-label"> Deskripsi </label>
                        <div style={{ paddingBottom: '10px'}}>
                        <input onChange={handleChange}
                            type="text"
                            name="descr"
                            id="descr"
                            className='form-control'
                            value={values.descr}
                            validation={{ touched: touched.descr, errors: errors.descr }}
                            props={{
                            onBlur: handleBlur,
                            }}
                        />
                        {touched.descr && errors.descr && <span style={{ color: 'red' }}>{errors.descr}</span>} 
                        </div>
                </div>
                <div className="col-xl-9 col-lg-12">
                    <div
                        className="table-responsive"
                        style={{ paddingTop: "15px" }}
                    >
                        <Wrapper>
                        <table className="table table-borderless mb-2px small text-nowrap h-100%">
                            <thead>
                            <tr>
                                <th style={{ width: "5%" }}></th>
                                <th>Module</th>
                                <th style={{ textAlign: "center" }}>Create</th>
                                <th style={{ textAlign: "center" }}>Read</th>
                                <th style={{ textAlign: "center" }}>Update</th>
                                <th style={{ textAlign: "center" }}>Delete</th>
                            </tr>
                            </thead>
                            <tbody>
                            {roleModul.map((row, index) => (
                                <React.Fragment key={index}>
                                <tr style={{ verticalAlign: "middle" }}>
                                    <td>
                                    {row.subMenu.length > 0 ? (
                                        <button
                                        className="btn"
                                        type='button'
                                        style={{ background: "transparent" }}
                                        onClick={() => toggleRow(index)}
                                        >
                                        <i className="fa fa-arrow-right"></i>
                                        </button>
                                    ) : null}
                                    </td>
                                    <td>
                                    <input
                                        onChange={(e) => {checkAll(row.id,'')}}
                                        type="checkbox"
                                        class="form-check-input"
                                        checked={row.all}
                                    />
                                    {row.name}
                                    </td>
                                    
                                    <td style={{ textAlign: "center" }}>
                                        <input
                                            onChange={(e) => {handleCheck(row.id, row.create, '', 'create')}}
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={row.create}
                                        />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                    <input
                                        onChange={(e) => {handleCheck(row.id, row.read,'', 'read')}}
                                        type="checkbox"
                                        class="form-check-input"
                                        checked={row.read}
                                    />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                    <input
                                        onChange={(e) => {handleCheck(row.id, row.update,'', 'update')}}
                                        type="checkbox"
                                        class="form-check-input"
                                        checked={row.update}
                                    />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                    <input
                                        onChange={(e) => {handleCheck(row.id, row.delete,'', 'delete')}}
                                        type="checkbox"
                                        class="form-check-input"
                                        checked={row.delete}
                                    />
                                    </td>
                                </tr>
                                {collapsedRows.includes(index) &&
                                    row.subMenu.map((dataChild, indexChild) => (
                                        <tr className="child-row">
                                        <td></td>
                                        <td style={{ paddingLeft: "20px" }}>
                                        <input
                                            onChange={(e) => {checkAll(dataChild.id,row.id)}}
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={dataChild.all}
                                        />
                                        {dataChild.name}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                        <input
                                            onChange={(e) => {handleCheck(dataChild.id, dataChild.create, row.id, 'create')}}
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={dataChild.create}
                                        />
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                        <input
                                            onChange={(e) => {handleCheck(dataChild.id, dataChild.read, row.id, 'read')}}
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={dataChild.read}
                                        />
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                        <input
                                            onChange={(e) => {handleCheck(dataChild.id, dataChild.update, row.id, 'update')}}
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={dataChild.update}
                                        />
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                        <input
                                            onChange={(e) => {handleCheck(dataChild.id, dataChild.delete, row.id, 'delete')}}
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={dataChild.delete}
                                        />
                                        </td>
                                    </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                        </Wrapper>
                    </div>
                </div>
            </div>
        </div>
    </form>
            )}
    </Formik>
  
      </ModalComponent>
    )
}

export default FormRole